var step=25,scrolling=!1;$("#scrollUp").bind("click",function(event){event.preventDefault(),$("#content").animate({scrollTop:"-="+step+"px"})}).bind("mouseover",function(event){scrolling=!0,scrollContent("up")}).bind("mouseout",function(event){scrolling=!1}),$("#scrollDown").bind("click",function(event){event.preventDefault(),$("#content").animate({scrollTop:"+="+step+"px"})}).bind("mouseover",function(event){scrolling=!0,scrollContent("down")}).bind("mouseout",function(event){scrolling=!1});function scrollContent(direction){var amount=direction==="up"?"-=1px":"+=1px";$("#content").animate({scrollTop:amount},1,function(){scrolling&&scrollContent(direction)})}
//# sourceMappingURL=/s/files/1/0624/1914/0823/t/54/assets/custom.js.map?v=1683046997

document.addEventListener("DOMContentLoaded", function(event) { 
  var productDescriptionTabsNavItems = document.querySelectorAll('.product-description-tabs-nav-item');
  var productDescriptionTabsBodyItems = document.querySelectorAll('.product-description-tabs-body-item');
  if (productDescriptionTabsNavItems.length && productDescriptionTabsBodyItems.length) {
    productDescriptionTabsNavItems.forEach(function(item) {
      item.addEventListener("click", function(event) { 
        var itemID = this.getAttribute('data-id');
        productDescriptionTabsNavItems.forEach(function(el) {
          el.classList.remove('active');
        });
        this.classList.add('active');
        productDescriptionTabsBodyItems.forEach(function(el) {
          if (el.getAttribute('data-id') == itemID) {
            el.classList.add('active');
          } else {
            el.classList.remove('active');
          }
        });
      });
    });
  }
});